export class WealthWebPortfolioAnalysisStoreMappingConfig {
	public static readonly risk = [
		'active.risk',
		'active.sleeves',
		'benchmark.scenarios',
		'benchmark.risk',
		'benchmark.tailRisk',
		'sleeves',
		'scenarios',
		'risk',
		'tailRisk'
	];
	public static readonly details = [
		'active.sleeve',
		'benchmark.breakdowns',
		'benchmark.characteristics',
		'benchmark.sleeves',
		'breakdowns',
		'characteristics',
		'sleeves',
		'customColumns',
		'ruleEvaluations',
		'esg'
	];
	public static readonly performance = [
		'benchmark.performance',
		'performance'
	];
	public static readonly wealthProjections = [
		'wealthProjections', // no benchmark is needed for wealth projections
		'risk', // this is needed for the expected risk
		'breakdowns' // needed for asset class, sub-asset class & cma asset class
	];

	public static readonly esg = [
		'esg'
	];

	public static readonly fundAnalytics = [
		'fundAnalytics',
		'performance',
		'risk'
	];

	public static readonly rules = [
		'ruleEvaluations'
	];

}
